import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { iframeUrl } from 'src/app/core/constant/iframeUrls';

@Component({
  selector: 'app-create-branch',
  templateUrl: './create-branch.component.html',
  styleUrls: ['./create-branch.component.scss']
})
export class CreateBranchComponent implements OnInit {
  iframeUrlCreateBranchRaw: any;

  constructor(
    private sanitizer: DomSanitizer,
    private router: Router,
  ) {

  }

  ngOnInit(): void {
    let iframeUrlCreateBranchRaw = iframeUrl.createBranch.url;
    this.iframeUrlCreateBranchRaw = this.sanitizer.bypassSecurityTrustResourceUrl(iframeUrlCreateBranchRaw);
  }

  BackToDashboard() {
    this.router.navigate(['dashboard']);
  }

}
